import { Outlet } from 'react-router-dom';
import { useInactivityTimeout } from '@/lib/auth/pin/useInactivityTimeout';

/**
 * Top-level layout for the whole app. We use this slot to hook in cross-cutting
 * behaviors that need router context (useNavigate) — currently the kiosk
 * inactivity watchdog. Concrete UI lives in the child routes.
 */
export function RootLayout() {
  useInactivityTimeout();
  return <Outlet />;
}
